import { OrderStatus } from 'interfaces';

export const orderStatusesWithVisibleAdditionalSections: OrderStatus[] = [
   'DELIVERED',
   'DURING_BILLING',
   'TO_PAY',
   'ENDED',
];
